import moment from 'moment-timezone';
import { DecitraitDiseaseId } from '../decitrait';
import mockedRequester from './mockedRequester';
const mockedConnectResponse = {
    epicureUsername: 'foo-login',
    password: 'pwd',
    organizationId: 137
};
const mockedCreateUserResponse = {
    email: 'testweenat@foo.com',
    epicureUsername: 'testweenat@foo.com',
    firstName: 'testweenat@foo.com',
    lastName: 'testweenat@foo.com',
    password: 'fezfzfzfzF678GY9',
    organizationId: 137
};
const mockedUserResponse = {
    postalCode: '44000',
    areaId: '33',
    departmentId: '33',
    town: 'Nantes',
    responsable: 'foobar',
    vineyardCastle: 'Château du côteau'
};
const mockedDecitraitResource = () => [{ id: '0', name: 'foo' }];
const mockedDecitraitNumberResource = () => [{ id: 0, name: 'foo' }];
const mockedGetResources = {
    area: mockedDecitraitResource(),
    grapeVariety: mockedDecitraitResource(),
    compactness: mockedDecitraitResource(),
    leafStripping: mockedDecitraitResource(),
    cropCover: mockedDecitraitResource(),
    fertilisation: mockedDecitraitResource(),
    plotHistory: mockedDecitraitResource(),
    normalizedDifferenceVegetationIndex: mockedDecitraitResource(),
    yesNo: mockedDecitraitResource(),
    rootstock: mockedDecitraitResource(),
    grapeBerryReceptivityPotential: mockedDecitraitResource(),
    contactRate: mockedDecitraitResource(),
    vigour: mockedDecitraitResource(),
    sensibility: mockedDecitraitResource(),
    trainingMethod: mockedDecitraitResource(),
    disease: mockedDecitraitResource(),
    stages: mockedDecitraitNumberResource()
};
const mockedDepartmentsByArea = [
    { id: '0', name: '44 - Foobar' }
];
const mockedPlots = [{ id: '1', name: 'foo' }];
const mockedCreatePlot = {
    plotId: 12,
    name: 'foobar',
    plotArea: 80,
    harvestDate: '1614851558',
    trainingMethod: '0',
    interPlant: 12,
    interRow: 42,
    mildewSensibility: '0',
    oidiumSensibility: '0',
    hadOidiumAttack: '0'
};
const mockedUpdatePlot = undefined;
const format = 'DD/MM/YYYY';
const mockedDiseases = {
    mildew: {
        protected: true,
        risk: '1',
        protectionNeeded: true,
        fta: '0.25',
        notes: { leaves: 3, grapes: 2 }
    },
    oidium: {
        protected: true,
        risk: '1',
        protectionNeeded: true,
        fta: '0.25',
        notes: { leaves: 3, grapes: 2 }
    }
};
const mockedSummary = [
    {
        date: moment('24/04/2021', format),
        blackrotProtection: 0,
        computedStage: 3,
        userSetStage: 3,
        ...mockedDiseases
    },
    {
        date: moment('25/04/2021', format),
        blackrotProtection: 0,
        computedStage: 3,
        userSetStage: 3,
        ...mockedDiseases
    },
    {
        date: moment('26/04/2021', format),
        blackrotProtection: 0,
        computedStage: 3,
        userSetStage: 3,
        ...mockedDiseases
    },
    {
        date: moment('27/04/2021', format),
        blackrotProtection: 0,
        computedStage: 3,
        userSetStage: 3,
        ...mockedDiseases
    },
    {
        date: moment('28/04/2021', format),
        blackrotProtection: 1,
        computedStage: 3,
        userSetStage: 3,
        ...mockedDiseases
    },
    {
        date: moment('29/04/2021', format),
        blackrotProtection: 0,
        computedStage: 3,
        userSetStage: 3,
        ...mockedDiseases
    }
];
const mockedLinkPlot = {
    plotId: 18790
};
const mockedPlotDetail = {
    plotArea: 3.4,
    name: 'foo',
    latitude: 14.2,
    longitude: -1.4,
    interPlant: 2.3,
    interRow: 3.4,
    harvestDate: '10/20',
    trainingMethod: '1',
    compactness: '1',
    mildewSensibility: '1',
    oidiumSensibility: '1',
    hadOidiumAttack: '1',
    grapeVariety: 'cabernet'
};
export const mockedProduct = {
    approvedDose: 3,
    id: '2',
    name: 'Product name',
    categories: ['3'],
    substances: { Foo: 43 },
    infos: ['foobar info']
};
const mockedProductsByDiseaseId = {
    1: [{ ...mockedProduct }],
    2: [{ ...mockedProduct, id: '2' }]
};
const mockedTreatmentCategories = [
    {
        id: 3,
        maxNumber: 2,
        codes: ['H3467']
    }
];
const mockedDeleteTreatment = undefined;
const mockedCreateSanitaryStateNote = undefined;
const mockedCreateTreatment = undefined;
export const mockedTreatmentDetail = {
    id: 3,
    treatmentDate: new Date(2020, 8, 20),
    foliageHeight: 3,
    foliageWidth: 5,
    mildewPressure: '2',
    oidiumPressure: '1',
    plots: [1],
    products: [
        {
            diseaseId: DecitraitDiseaseId.mildew,
            productId: '2',
            quantity: 340,
            batchNumber: '2'
        }
    ]
};
const mockedTreatmentsPerYear = [
    { ...mockedTreatmentDetail }
];
const mockedOptidose = {
    doses: [],
    copperDose: 89
};
const mock = {
    optidose: mockedRequester(mockedOptidose, 'decitrait.optidose'),
    createSanitaryStateNote: mockedRequester(mockedCreateSanitaryStateNote, 'decitrait.createSanitaryStateNote'),
    deleteTreatment: mockedRequester(mockedDeleteTreatment, 'decitrait.deleteTreatment'),
    treatmentDetail: mockedRequester(mockedTreatmentDetail, 'decitrait.treatmentDetail'),
    treatmentsPerYear: mockedRequester(mockedTreatmentsPerYear, 'decitrait.treatmentsPerYear'),
    createTreatment: mockedRequester(mockedCreateTreatment, 'decitrait.createTreatment'),
    treatmentCategories: mockedRequester(mockedTreatmentCategories, 'decitrait.treatmentCategories'),
    products: mockedRequester(mockedProductsByDiseaseId, 'decitrait.products'),
    plotDetail: mockedRequester(mockedPlotDetail, 'decitrait.plotDetail'),
    connect: mockedRequester(mockedConnectResponse, 'decitrait.connect'),
    createUser: mockedRequester(mockedCreateUserResponse, 'decitrait.createUser'),
    getUser: mockedRequester(mockedUserResponse, 'decitrait.getUser'),
    configureUser: mockedRequester(mockedUserResponse, 'decitrait.configureUser'),
    getResources: mockedRequester(mockedGetResources, 'decitrait.getResources'),
    departmentsByArea: mockedRequester(mockedDepartmentsByArea, 'decitrait.departmentsByArea'),
    summary: mockedRequester(mockedSummary, 'decitrait.summary'),
    plots: mockedRequester(mockedPlots, 'decitrait.plots'),
    createPlot: mockedRequester(mockedCreatePlot, 'decitrait.createPlot'),
    updatePlot: mockedRequester(mockedUpdatePlot, 'decitrait.updatePlot'),
    linkPlot: mockedRequester(mockedLinkPlot, 'decitrait.linkPlot'),
    setStage: mockedRequester(undefined, 'decitrait.linkPlot')
};
export default mock;
